import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { IUsersService } from 'libs/core/src/lib/services/users.service';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import {
  IPaginatedResponse,
  IRepresentative,
  IRepresentativeRequest,
  IUserQueryParams,
} from '@inshuwa-client/models';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PartnerUserService implements IUsersService {
  constructor(
    private rep: RepresentativeService,
    private http: HttpClient,
  ) {}
  getUsers(
    _queryParams?: Partial<IUserQueryParams> | undefined,
  ): Observable<IPaginatedResponse<IRepresentative>> {
    throw new Error('Method not implemented.');
  }

  addUser(
    data?: Partial<IRepresentativeRequest> | undefined,
  ): Observable<IRepresentative> {
    const partner = this.rep.getLoggedInPartnerRepresentative().partner;
    return this.http.post<IRepresentative>(
      `${baseUrl()}/partners/${partner.id}/representatives`,
      {
        partnerId: partner.id,
        ...data,
      },
    );
  }
  
}
